export default __webpack_public_path__ + "static/media/spa-image-17.280aadcd.jpg";